import { getBaseUrl } from '../utils/apiHelper';
import Cookies from 'js-cookie';

// Log base URL for debugging API endpoint construction
const baseUrl = getBaseUrl();
console.log('🌐 API Base URL:', baseUrl);

const API_BASE_URL = `${baseUrl}/api/completed`;
const COUNTS_URL = `${API_BASE_URL}/counts`;
console.log('🔗 Completed API Base URL:', API_BASE_URL);
console.log('🔗 Completed Counts URL:', COUNTS_URL);

const completedService = {// Fetch completed counts with optional filters for userId, itemType, and date range
    getCompletedCounts: async (filters = {}) => {
        try {
            const { userId, itemType, startDate, endDate } = filters;
            console.log('📊 getCompletedCounts called with filters:', { userId, itemType, startDate, endDate });
            
            const token = Cookies.get('token');
            
            if (!token) {
                console.error('❌ No authentication token found in cookies');
                throw new Error('Authentication token not found');
            }
            console.log('🔑 Token retrieved:', token.substring(0, 10) + '...');
              // Build query parameters
            const params = new URLSearchParams();
            if (userId) params.append('userId', userId);
            if (itemType) params.append('itemType', itemType);
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);
            
            const queryString = params.toString();
            const url = queryString ? `${COUNTS_URL}?${queryString}` : COUNTS_URL;
            console.log('🔍 Sending request to URL:', url);
            
            console.log('📤 Request headers:', {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token.substring(0, 10)}...`
            });
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            
            console.log('📥 Response status:', response.status, response.statusText);
            
            if (!response.ok) {
                const error = await response.json();
                console.error('❌ API error response:', error);
                throw new Error(error.message || 'Failed to fetch completion data');
            }
              const data = await response.json();
            console.log('✅ API response data:', data);
            
            // Check if data has the expected structure
            if (!data || !data.data) {
                console.warn('⚠️ Unexpected API response format:', data);
                // Return empty array if data is not in expected format
                return data.data || [];
            }
            
            return data.data;
        } catch (error) {
            console.error('❌ Error in getCompletedCounts:', error);
            throw error;
        }
    },      // Get detailed activity for a specific user on a specific date
    getUserDailyActivity: async (userId, date) => {
        try {
            console.log('📊 getUserDailyActivity called with:', { userId, date });
            const token = Cookies.get('token');
            
            if (!token) {
                console.error('❌ No authentication token found in cookies');
                throw new Error('Authentication token not found');
            }
            console.log('🔑 Token retrieved:', token.substring(0, 10) + '...');
            
            const params = new URLSearchParams();            params.append('userId', userId);
            params.append('date', date);
            params.append('detailed', 'true');
            
            const url = `${API_BASE_URL}/details?${params.toString()}`;
            console.log('🔍 Sending request to URL:', url);
            
            console.log('📤 Request headers:', {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token.substring(0, 10)}...`
            });
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            
            console.log('📥 Response status:', response.status, response.statusText);
            
            if (!response.ok) {
                const error = await response.json();
                console.error('❌ API error response:', error);
                throw new Error(error.message || 'Failed to fetch user activity details');
            }
              const data = await response.json();
            console.log('✅ Daily activity data received:', data);
            
            // Check if data has the expected structure
            if (!data || !data.data) {
                console.warn('⚠️ Unexpected API response format for daily activity:', data);
                // Return empty array if data is not in expected format
                return data.data || [];
            }
            
            return data.data;
        } catch (error) {
            console.error('❌ Error in getUserDailyActivity:', error);
            throw error;
        }
    }
};

export default completedService;
